 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "sports2-static/chunk." + ({"0":"source~/esports-betting-rules-TR~bet-builder-rules-DE~bet-builder-rules-EN~bet-builder-rules-ES~bet-~078fb09e","1":"source~/esports-betting-rules-TR~bet-builder-rules-DE~bet-builder-rules-EN~bet-builder-rules-ES~bet-~e20a97ce","2":"source~/esports-betting-rules-TR~esports-betting-rules-DA~esports-betting-rules-DE~esports-betting-r~11b5dbfd","5":"source~virtual-esports-betting-rules-EN~virtual-esports-betting-rules-IT~virtual-esports-betting-rul~c400071f","8":"source~bet-details-page~betting-history-page","9":"source~i18n-widgets-en-json","10":"source~i18n-widgets-tr-json","13":"source~/esports-betting-rules-TR","14":"source~bet-builder-rules-DE","15":"source~bet-builder-rules-EN","16":"source~bet-builder-rules-ES","17":"source~bet-builder-rules-ES-MX","18":"source~bet-builder-rules-ET","19":"source~bet-builder-rules-FI","20":"source~bet-builder-rules-FR","21":"source~bet-builder-rules-IT","22":"source~bet-builder-rules-JA","23":"source~bet-builder-rules-KA","24":"source~bet-builder-rules-LT","25":"source~bet-builder-rules-LV","26":"source~bet-builder-rules-PL","27":"source~bet-builder-rules-PT-BR","28":"source~bet-builder-rules-RO","29":"source~bet-builder-rules-RU","30":"source~bet-builder-rules-SQ","31":"source~bet-builder-rules-TR","32":"source~bet-details-page","33":"source~betting-history-container","34":"source~betting-history-page","35":"source~betting-rules-DA","36":"source~betting-rules-DE","37":"source~betting-rules-EN","38":"source~betting-rules-ES","39":"source~betting-rules-ES-MX","40":"source~betting-rules-FR","41":"source~betting-rules-IT","42":"source~betting-rules-JA","43":"source~betting-rules-PL","44":"source~betting-rules-PT","45":"source~betting-rules-PT-BR","46":"source~betting-rules-RO","47":"source~betting-rules-RU","48":"source~betting-rules-SQ","49":"source~betting-rules-TR","50":"source~bonus-info","51":"source~cashout-terms-AR","52":"source~cashout-terms-DA","53":"source~cashout-terms-DE","54":"source~cashout-terms-EN","55":"source~cashout-terms-ES","56":"source~cashout-terms-ES-MX","57":"source~cashout-terms-ET","58":"source~cashout-terms-FI","59":"source~cashout-terms-FR","60":"source~cashout-terms-IT","61":"source~cashout-terms-JA","62":"source~cashout-terms-KA","63":"source~cashout-terms-KU","64":"source~cashout-terms-LT","65":"source~cashout-terms-LV","66":"source~cashout-terms-PL","67":"source~cashout-terms-PT","68":"source~cashout-terms-PT-BR","69":"source~cashout-terms-RO","70":"source~cashout-terms-RU","71":"source~cashout-terms-SQ","72":"source~cashout-terms-SR","73":"source~cashout-terms-TR","74":"source~esports-betting-rules-DA","75":"source~esports-betting-rules-DE","76":"source~esports-betting-rules-EN","77":"source~esports-betting-rules-ES","78":"source~esports-betting-rules-ES-MX","79":"source~esports-betting-rules-ET","80":"source~esports-betting-rules-FI","81":"source~esports-betting-rules-FR","82":"source~esports-betting-rules-IT","83":"source~esports-betting-rules-JA","84":"source~esports-betting-rules-KA","85":"source~esports-betting-rules-LT","86":"source~esports-betting-rules-LV","87":"source~esports-betting-rules-PL","88":"source~esports-betting-rules-PT","89":"source~esports-betting-rules-PT-BR","90":"source~esports-betting-rules-RO","91":"source~esports-betting-rules-RU","92":"source~esports-betting-rules-SQ","93":"source~esports-betting-rules-SR","95":"source~generated-mappings","96":"source~i18n-en-json","97":"source~i18n-tr-json","99":"source~settings-page","100":"source~streaming-carousel","101":"source~virtual-esports-betting-rules-EN","102":"source~virtual-esports-betting-rules-IT","103":"source~virtual-esports-betting-rules-JA","104":"source~virtual-esports-betting-rules-PL","106":"vendors~rc-slider","107":"vendors~react-google-recaptcha","108":"vendors~streaming-carousel"}[chunkId]||chunkId) + "." + {"0":"d266b05cb36076fe8301","1":"f475c88e0f9305b7dae3","2":"1175928895c7caa293e9","3":"de9ebc35c2e1d704babe","4":"1dab3feabcd1f0b9a229","5":"3e81f2083f09e72c207f","6":"df395042098eab122fe9","8":"1fca1fc00f8b757210fd","9":"2cfbc09e0f1e576e2872","10":"3a3886af592da73c0280","13":"2edbb4489f34a53654f6","14":"85ac04158668fd2fc9f1","15":"f17cca8a3cb7f2666e5e","16":"1083df22001ab7d8d483","17":"42a53c819016eb53cb0f","18":"95c8a4088523be3e497e","19":"b2c41cbb42234ba0bfd9","20":"3bfbdfe8c7f5528d8730","21":"86c56cc691444ef37635","22":"b9749e5eee7d94b243f3","23":"ef77663cc90e644bbb4d","24":"0c69df7afccf32cb169e","25":"cb637d9f7a16207695ec","26":"6bffeda1cd9b0fda0681","27":"a1a6885702718f2c111b","28":"5d0cf3bd3dbfee47e05d","29":"c650ab00ff2ec7720893","30":"fd9fbe0db15c9217f53f","31":"5eb81d4adcfb9c297480","32":"cf40c891229ba92fff23","33":"a0e2fee5091a632cfb01","34":"bd19fb1da7a47fff122b","35":"ba9c89e917a0cc8219bc","36":"d7e58e57d5dc24147b22","37":"f423be651bb3457fd6b9","38":"3446e2fbaa1a7ca2d9f6","39":"eb09ed0c469a04f4cba8","40":"9ec598ed26683ffab244","41":"bb4ad25b599a3442db75","42":"0e7e5a347d89650157b5","43":"b50a9838d7b63d1342ab","44":"ccacbacb26ef475b45d7","45":"0284a82de0e75c255a10","46":"d3fa53905876891edde4","47":"0fbc1729587731a3eab1","48":"69dc5a136266a21e5bc8","49":"e0a975c7769c0e901973","50":"2a1554a528d5eac42a8d","51":"256fa09d2d61bd6099f3","52":"03b28ac0708f8ab63090","53":"8b53c4354e4eee7b5b27","54":"83d556c26d00142a3051","55":"40b96feb307790215579","56":"2b940a993c51b8c65ed7","57":"6df7c66faebd5b9dad4a","58":"f1dab619f37831f5c6a3","59":"d5c1cd05d7e7de204d9e","60":"f57f77fd7505cb999a1f","61":"651385b70b65a73068d7","62":"2473e17c42ac2e9dc850","63":"b526669ee29f73201292","64":"bd16baa8a7ab2c4cc142","65":"6e34e08fc5723d01e5f5","66":"15fed4ce49301e54a233","67":"7ef4269c89cd9d7020db","68":"81fe93cfd32171f82da2","69":"1b0898ac9b4e36efe7a7","70":"9224f2f269dd45d8b0b4","71":"311106460a82e6b2b79f","72":"ecdfdae2c49938ddf7d3","73":"3f0db0759e815d513143","74":"f4107a9e46a170e5e659","75":"51c10653f153d4dec954","76":"9c5dc29a0896dae6ca90","77":"ad7daa7750c61f843222","78":"0a014cd2ca338aa8c41a","79":"ee8932abd328086ea719","80":"5dc89ddb9f31d75aa716","81":"a2ee7c8b1ce0859b5c9e","82":"c2b6f606de534405c315","83":"6778a2d8b705f363082a","84":"85e01eca2ae29fc492cb","85":"3e52dd2dd9b7358358eb","86":"bdbc75938ece401a00e2","87":"1d7fe2acbac9d5be567c","88":"c74ca355f799c75f3600","89":"6ce59dcf24dd41cb341f","90":"344c5c893d26bd2c5a74","91":"83172e67352e1b7b2bf9","92":"8b6abf04365a77751568","93":"7cf7a403b4b5acdf0c16","95":"78504644c91d75445fd7","96":"868a2118bc9c238d7e9e","97":"bafe65ca05f61c7fd9ea","99":"01350c1a32c88dfc9313","100":"4f87be8d3a54938e93fb","101":"d5dc0e69ab38d3973df7","102":"6ac1bb0fac60e6dca1fc","103":"f84713af1ec188e4f0cf","104":"fedd6f6f328141af6ba1","106":"af35e6631a6eb02f414a","107":"7cf9a7d56b764421793a","108":"6f24ea645911b01e8994","109":"283876055a9c2d9d4666","110":"791f6c36d0820a1b18c6","111":"ad79d58f27cfb8589eba","112":"6ef0040259a44d87773b","113":"0c8712071c75c5df2686","114":"0437f00cdf3dcf5ad2d5","115":"60928aa53dff30fbbb08","116":"97d6491f20e27f48d717","117":"0130024815969b7d00c9","118":"4c412ae9615814491f81","119":"13c030f12cf4e00b1da4","120":"a5f5f7500887224bc230","121":"fbe35124d3487b8ddcc4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpOMFE2_App"] = window["webpackJsonpOMFE2_App"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
